var React = require('react');

function Laravel (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"#FFFFFF","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"2","d":"M49 24L43.503 16.025 36 18 48.007 35.714 31 42 11.999 8.998 1 11 13 34z"}));
}

Laravel.defaultProps = {"fill":"#FFFFFF","viewBox":"0 0 50 50","width":"50px","height":"50px"};

module.exports = Laravel;

Laravel.default = Laravel;
